import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { OrderWizardNavigationService } from "../../_service/order-wizard-navigation.service";

@Component({
    selector: 'order-wizard-header',
    templateUrl: './order-wizard-header.component.html',
    styleUrls: ['./order-wizard-header.component.scss'],
    imports: [CommonModule, TranslateModule]
})
export class OrderWizardHeaderComponent implements OnInit {

    constructor(
        public _orderWizardNavigationService: OrderWizardNavigationService
    ) {

     }

    ngOnInit(): void {
 
    }


}